import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import { GetFiscalPrinterLocationDto } from '../autogenerated/spdApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { fiscalPrinterLocationForGrid } from '../../../spd/components/FiscalPrinterLocation/FiscalPrinterLocationSearch';
import {
  CreateUpdateFiscalPrinterLocationDto,
  CreateUpdateFiscalPrinterLocationDtoFromJSON,
} from '../autogenerated/spdApiClient/models/CreateUpdateFiscalPrinterLocationDto';
import { validateAgainst } from '../validation/validateAgainst';
import { FiscalPrinterLocationSchema } from '../validation/schemas';

export interface FiscalPrinterLocationContextInterface {
  get: (id: string) => Promise<GetFiscalPrinterLocationDto>;
  getAllCount: (filterText?: string) => Promise<number>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
  ) => Promise<GridRecord[]>;
  update: (
    id: string,
    dto: CreateUpdateFiscalPrinterLocationDto,
  ) => Promise<void>;
  create: (
    dto: CreateUpdateFiscalPrinterLocationDto,
  ) => Promise<GetFiscalPrinterLocationDto>;
  delete: (id: string) => Promise<void>;
}

export const FiscalPrinterLocationContext = (api: DefaultApi) => {
  return {
    get: async (id: string) => {
      return await api.fiscalPrinterLocationControllerGet(id);
    },

    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) => {
      const data = await api.fiscalPrinterLocationControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
      );
      return data.map(fiscalPrinterLocationForGrid);
    },

    getAllCount: (filterText?: string) =>
      api.fiscalPrinterLocationControllerGetAllCount(filterText || ''),

    update: (id: string, dto: CreateUpdateFiscalPrinterLocationDto) =>
      api.fiscalPrinterLocationControllerUpdate(id, dto),

    create: (dto: CreateUpdateFiscalPrinterLocationDto) =>
      api.fiscalPrinterLocationControllerCreate(dto),

    delete: (id: string) => api.fiscalPrinterLocationControllerDelete(id),
  };
};

export const validate = (dto: CreateUpdateFiscalPrinterLocationDto) => {
  return validateAgainst(FiscalPrinterLocationSchema, dto);
};

export const fiscalPrinterLocationData = (
  location?: GetFiscalPrinterLocationDto,
): CreateUpdateFiscalPrinterLocationDto => {
  return CreateUpdateFiscalPrinterLocationDtoFromJSON({
    ...location,
  });
};
